import type { SVGProps } from "react";

const RechargesIcon = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      fillRule="evenodd"
      d="M10.417 2.083H9.375c-2.946 0-4.42 0-5.335.916-.915.915-.915 2.388-.915 5.335v13.802h13.542V8.334c0-2.947 0-4.42-.916-5.335-.915-.916-2.388-.916-5.334-.916Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      d="M3.125 22.135H2.083a.781.781 0 1 0 0 1.563H17.97a.781.781 0 0 0 0-1.563H3.125Z"
    />
    <path
      fill="#FBFBFB"
      d="M10.566 10.819a.781.781 0 0 0-1.34-.804l-1.563 2.604a.781.781 0 0 0 .67 1.183h1.745l-.852 1.421a.781.781 0 1 0 1.34.804l1.562-2.604a.782.782 0 0 0-.67-1.184H9.713l.853-1.42Z"
    />
    <path
      fill="#000"
      d="M16.667 18.23h1.636c.39 0 .707.316.707.706v.074a2.344 2.344 0 1 0 4.688 0V7.658c0-.163 0-.276-.006-.385a3.906 3.906 0 0 0-1.293-2.69 6.999 6.999 0 0 0-.297-.246L20.8 3.297a.781.781 0 1 0-.976 1.22l1.285 1.027c.15.12.202.162.247.202.462.414.74.995.776 1.614.003.06.003.127.003.32v.393h-.78c-.864 0-1.563.7-1.563 1.562v2.52c0 .673.43 1.27 1.068 1.482l1.275.425v4.948a.781.781 0 0 1-1.562 0v-.074a2.27 2.27 0 0 0-2.27-2.27h-1.636v1.563Z"
    />
  </svg>
);
export default RechargesIcon;
